import { z } from 'zod';
import type {
  ListCoverShipmentsRequest,
  ListCoverShipmentsResponse,
} from './list-cover-shipments.dto.js';
import { CoverShipmentHeaderSchema } from './cover-shipments-shared.schema.js';
import { CoverShipmentStatusSchema } from './cover-shipments-types.js';

export const ListCoverShipmentsRequestSchema: z.ZodType<ListCoverShipmentsRequest> = z
  .object({
    companyId: z.uuid(),
    materialId: z.uuid().optional(),
    statuses: z.array(CoverShipmentStatusSchema).optional(),
  })
  .strict();

export const ListCoverShipmentsResponseSchema: z.ZodType<ListCoverShipmentsResponse> = z
  .object({
    items: z.array(CoverShipmentHeaderSchema),
  })
  .strict();
